<div class="list-container">
  <div class="image" data-test="thumbnail">
    <img *ngIf="imageUrl" [lazyLoad]="imageUrl | floImage: 116 | async" />
  </div>
  <div class="list-info">
    <p class="title apply-text-hover" data-test="title">{{ title }}</p>
    <ng-content></ng-content>
  </div>
</div>
